import styled from 'styled-components';

export const Container = styled.div`
  display: none;
  padding-bottom: 1rem;
  width: 100%;
  max-width: 100vw;
  position: relative;

  .swiper {
    overflow: visible;
  }

  img {
    width: 100%;
    max-width: 100vw;
  }

  .swiper-button-prev,
  .swiper-button-next {
    display: none;
  }

  .swiper-pagination {
    bottom: -1rem !important;
  }

  .swiper-pagination-bullet {
    transition: all 0.3s ease;
  }

  .swiper-pagination .swiper-pagination-bullet-active {
    width: 1rem;
    border-radius: 0.4rem;
    background-color: var(--green_blue);
  }
`;
